import {
  aboutUs,
  boMerchant,
  buyingGuides,
  cookiePolicy,
  dataProtection,
  help,
  hireExternal,
  infosConsumer,
  legal,
  medium,
  modelsComparison,
  referFriend,
  studentGoodDeals,
  termsSale,
  termsUse,
} from './shared-links'
import type { FooterConfig } from './types'

export const seConfig: FooterConfig = {
  columns: [
    {
      titleKey: 'categoryAbout',
      links: [aboutUs, studentGoodDeals, hireExternal],
      socials: [
        {
          name: 'linkedin',
          href: 'https://www.linkedin.com/company/back-market',
        },
        { name: 'facebook', href: 'https://www.facebook.com/backmarket' },
        { name: 'x', href: 'https://x.com/backmarket' },
      ],
    },
    {
      titleKey: 'categoryHelp',
      links: [
        {
          translationKey: 'becomeRefurbisher',
          href: 'https://backmarket.se/sv-se/seller/home ',
        },
        boMerchant,
        {
          translationKey: 'payment',
          href: 'https://help.backmarket.com/hc/sv/articles/360026643854',
        },
        {
          translationKey: 'shipping',
          href: 'https://help.backmarket.com/hc/sv/articles/360026646054-Vilka-l%C3%A4nder-levererar-Back-Market-till-och-vilka-%C3%A4r-de-olika-fraktalternativen',
        },
        {
          translationKey: 'return',
          href: 'https://help.backmarket.com/hc/sv/categories/360002106194-Returns-Refunds--Devoluciones-y-reembolsos--%CE%95%CF%80%CE%B9%CF%83%CF%84%CF%81%CE%BF%CF%86%CE%AD%CF%82-%CE%91%CF%80%CE%BF%CE%B6%CE%B7%CE%BC%CE%B9%CF%8E%CF%83%CE%B5%CE%B9%CF%82-Reso-del-prodotto-e-rimborsi-Returns-Refunds--Retours-Remboursements-Retouren-en-terugbetalingen-Returns-refunds-',
        },
        help,
        buyingGuides,
        modelsComparison,
      ],
    },
    {
      titleKey: 'categoryServices',
      links: [referFriend],
    },
    {
      titleKey: 'categoryLaw',
      links: [
        termsUse,
        termsSale,
        dataProtection,
        cookiePolicy,
        infosConsumer,
        legal,
        {
          translationKey: 'illegalContent',
          href: 'https://help.backmarket.com/hc/sv/requests/new?ticket_form_id=12226993197084',
        },
        {
          translationKey: 'paymentMethods',
          href: 'https://help.backmarket.com/hc/sv/articles/360026643854-Vilka-betalningsmetoder-accepteras-p%C3%A5-Back-Market',
        },
      ],
    },
    {
      titleKey: 'categoryHello',
      links: [
        {
          translationKey: 'trustpilot',
          href: 'https://www.trustpilot.com/review/backmarket.se',
        },
        medium,
      ],
    },
    {
      logos: ['bcorp'],
    },
  ],
}
